<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Modifica Chilometri Viaggio</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form name="form" class="form-travel" #travelForm="ngForm" novalidate>
            <div class="form-group">
                <label for="start_kilometers">Km Iniziali</label>
                <input type="number" min="0" max="9999999"  class="form-control height250" id="start_kilometers"
                       [(ngModel)]="travel.start_kilometers"
                       maxlength="250" name="start_kilometers" #start_kilometers="ngModel" required
                       [ngClass]="{ 'is-invalid': error }">
                <div *ngIf="!travelForm.valid" class="invalid-feedback">
                    Il campo Chilometri Iniziali è obbligatorio
                </div>
            </div>
            <div class="form-group">
                <label for="end_kilometers">Km Finali</label>
                <input type="number" min="0" max="9999999"  class="form-control height250" id="end_kilometers"
                       [(ngModel)]="travel.end_kilometers" maxlength="250"
                       name="end_kilometers" #end_kilometers="ngModel" required
                       [ngClass]="{ 'is-invalid': error }">
                <div *ngIf="!travelForm.valid" class="invalid-feedback">
                    Il campo Chilometri Finali è obbligatorio
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalRef.hide()">Annulla</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal"
                (click)="changeKm(travelForm)">Modifica</button>
    </div>
</ng-template>
